<template>
  <div class="writtenGrade" :class="{ 'isProp': testPlanId }">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="考场名称" v-if="!testPlanId">
          <el-input v-model="filter.title" placeholder="请输入考场名称"></el-input>
        </el-form-item>
        <el-form-item label="考试项目" v-if="!testPlanId">
          <el-input v-model="filter.testProject" placeholder="请输入考试项目"></el-input>
        </el-form-item>
        <el-form-item label="班级名称" v-if="!testPlanId">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="综合评定成绩" v-if="!testPlanId">
          <el-select v-model="filter.evaluationAll" placeholder="请选择综合评定成绩" clearable>
            <el-option label="合格" value="合格"></el-option>
            <el-option label="不合格" value="不合格"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试类型" v-if="!testPlanId">
          <el-select v-model="filter.type" placeholder="请选择考试类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="理论考试" :value="1"></el-option>
            <el-option label="实操考试" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="filter.contractSignName" placeholder="请输入学员姓名"></el-input>
        </el-form-item>
        <el-form-item v-if="!testPlanId" label="教务服务方名称">
          <el-input v-model="filter.agentName" placeholder="请输入教务服务方名称"></el-input>
        </el-form-item>
        <el-form-item v-if="!testPlanId" label="招生服务方名称">
          <el-input v-model="filter.distributName" placeholder="请输入招生服务方名称"></el-input>
        </el-form-item>
        <el-form-item label="专业岗位名称" v-if="!testPlanId">
          <el-input v-model="filter.professionalPosition" placeholder="请输入专业岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filter.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="证件号码" v-if="testPlanId">
          <el-input v-model="filter.contractSignIdCard" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
          <el-button size="small" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button size="small" type="primary" @click="downloadTemplate">下载成绩模版</el-button>
        <el-upload
          action=""
          :http-request="handleImportScore"
          :show-file-list="false"
          style="display:inline-block;margin-left:10px"
        >
          <el-button size="small" :disabled="!list || list.length === 0" type="primary">导入成绩</el-button>
        </el-upload>&emsp;
        <el-input v-model="addCustomPhone" placeholder="请输入手机号" style="width:136px;" size="small" />
        <el-button
          :disabled="addCustomPhone.length !== 11"
          type="primary" size="small"
          style="margin-left:-8px;position:relative;z-index:9999"
          @click="toAdd"
        >添加学员</el-button>
        <el-button type="primary" size="small" plain @click="toViewRecord">添加记录</el-button>
      </el-row>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table :data="list" border>
        <el-table-column key="1" v-if="!testPlanId" align="center" label="考场名称" prop="title" width="180px"></el-table-column>
        <el-table-column key="2" v-if="!testPlanId" align="center" label="班级名称" prop="skuName" width="180px"></el-table-column>
        <el-table-column key="3" v-if="!testPlanId" align="center" label="考试项目" prop="testProject" width="120px"></el-table-column>
        <el-table-column key="3-1" v-if="!testPlanId" align="center" label="考试类型" width="120px">
          <template v-slot="{ row }">
            <span v-if="row.type === 1">理论考试</span>
            <span v-else-if="row.type === 2">实操能力考核</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column key="4" v-if="!testPlanId" align="center" label="学员姓名" prop="contractSignName" width="120px"></el-table-column>
        <el-table-column key="21" v-if="!testPlanId" align="center" label="教务服务方名称" prop="agentName" minWidth="120"></el-table-column>
        <el-table-column key="22" v-if="!testPlanId" align="center" label="招生服务方名称" prop="distributName" minWidth="120"></el-table-column>
        <el-table-column key="5" v-if="!testPlanId" align="center" label="考试状态" prop="testStatus" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.testStatus === 9">正常</span>
            <span v-if="scope.row.testStatus === 11">舞弊</span>
            <span v-if="scope.row.testStatus === 12">缺考</span>
          </template>
        </el-table-column>
        <el-table-column key="5-1" v-if="!testPlanId" align="center" label="学员手机号" prop="phone" width="150px">
          <template v-slot="{ row }">
            <span>{{ row.phone || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="6" v-if="!testPlanId" align="center" label="身份证号" prop="contractSignIdCard" width="180px"></el-table-column>
        <el-table-column key="7" v-if="!testPlanId" align="center" label="专业岗位名称" prop="professionalPosition" width="180px"></el-table-column>
        <el-table-column key="8" v-if="!testPlanId" align="center" label="操作技能成绩" prop="operation" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.operation || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="9" v-if="!testPlanId" align="center" label="理论知识技能" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.theory || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10" v-if="!testPlanId" align="center" label="综合评定成绩" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.evaluationAll || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-1" v-if="!testPlanId" align="center" label="实操考试总分" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalScore || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-2" v-if="!testPlanId" align="center" label="内容创作" prop="practicalContentCreation" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalContentCreation || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-3" v-if="!testPlanId" align="center" label="语言表达" prop="practicalLanguageExpression" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalLanguageExpression || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-4" v-if="!testPlanId" align="center" label="镜头表现" prop="practicalScreenPresence" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalScreenPresence || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-5" v-if="!testPlanId" align="center" label="数据分析" prop="practicalDataAnalysis" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalDataAnalysis || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column key="10-6" v-if="!testPlanId" align="center" label="策划运营" prop="practicalPlanOperation" width="120px">
          <template v-slot="{ row }">
            <span>{{ row.practicalPlanOperation || '/' }}</span>
          </template>
        </el-table-column>

        <!-- 弹窗数据  -->
        <el-table-column key="11" v-if="testPlanId" align="center" label="学员姓名" prop="contractSignName" width=""></el-table-column>
        <el-table-column key="23" v-if="testPlanId" align="center" label="教务服务方名称" prop="agentName" minWidth="120"></el-table-column>
        <el-table-column key="24" v-if="testPlanId" align="center" label="招生服务方名称" prop="distributName" minWidth="120"></el-table-column>
        <el-table-column key="12" v-if="testPlanId" align="center" label="证件类型" prop="contractSignType" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.contractSignType == 1">身份证</span>
            <span v-if="scope.row.contractSignType == 2">护照</span>
            <span v-if="scope.row.contractSignType == 3">军官证</span>
            <span v-if="scope.row.contractSignType == 4">港澳台证件</span>
          </template>
        </el-table-column>
        <el-table-column key="13" v-if="testPlanId" align="center" label="证件号码" prop="contractSignIdCard" minWidth="170"></el-table-column>
        <el-table-column key="14" v-if="testPlanId" align="center" label="手机号" prop="phone" minWidth="150"></el-table-column>
        <el-table-column key="15" v-if="testPlanId" align="center" label="报名时间" prop="insertDate" minWidth="160"></el-table-column>
        <el-table-column key="16" v-if="testPlanId" align="center" label="学员考试时间" prop="testFrom" minWidth="160"></el-table-column>
        <el-table-column key="17" v-if="testPlanId" align="center" label="考试状态" prop="testStatus" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.testStatus === 9">正常</span>
            <span v-if="scope.row.testStatus === 11">舞弊</span>
            <span v-if="scope.row.testStatus === 12">缺考</span>
          </template>
        </el-table-column>
        <template v-if="type === 1">
          <el-table-column key="18" v-if="testPlanId" align="center" label="操作技能成绩" prop="operation" minWidth="120"></el-table-column>
          <el-table-column key="19" v-if="testPlanId" align="center" label="理论知识技能" prop="theory" minWidth="120"></el-table-column>
          <el-table-column key="20" v-if="testPlanId" align="center" label="综合评定成绩" prop="evaluationAll" minWidth="120"></el-table-column>
        </template>
        <template v-else-if="type === 2">
          <el-table-column key="25" v-if="testPlanId" align="center" label="总分" prop="practicalScore" minWidth="120"></el-table-column>
          <el-table-column key="26" v-if="testPlanId" align="center" label="内容创作" prop="practicalContentCreation" minWidth="120"></el-table-column>
          <el-table-column key="27" v-if="testPlanId" align="center" label="语言表达" prop="practicalLanguageExpression" minWidth="120"></el-table-column>
          <el-table-column key="28" v-if="testPlanId" align="center" label="镜头表现" prop="practicalScreenPresence" minWidth="120"></el-table-column>
          <el-table-column key="29" v-if="testPlanId" align="center" label="数据分析" prop="practicalDataAnalysis" minWidth="120"></el-table-column>
          <el-table-column key="30" v-if="testPlanId" align="center" label="策划运营" prop="practicalPlanOperation" minWidth="120"></el-table-column>
        </template>
        <el-table-column key="999" align="center" label="操作" fixed="right" width="240">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" v-if="row.isCancel === 1" @click="toCancle(row)">取消报名</el-button>
            <el-button type="text" size="mini" v-if="row.imgUrl" @click="lookPic(row)">查看证件照片</el-button>
            <el-button type="text" size="mini" v-if="type === 2" @click="toEditScore(row)">修改成绩</el-button>
            <el-button type="text" size="mini" @click="toDelete(row)">删除学员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-image-viewer v-if="isShow" :on-close="closeImgViewer" :url-list="[imgUrl]"></el-image-viewer>
    <!-- 选择班级 -->
    <el-dialog
      title="选择班级"
      :visible.sync="skuDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true">
      <el-form size="small" label-width="80px">
        <el-form-item label="班级：">
          <el-select v-model="selectedSkuId" placeholder="请选择班级" style="width: 100%">
            <el-option
              v-for="item in skuList"
              :key="item.skuId"
              :label="item.skuName"
              :value="item.skuId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="skuDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :disabled="!selectedSkuId" @click="confirmSkuAndAdd">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加考生 - 补全信息 -->
    <el-dialog
      title="补全信息"
      :visible.sync="addDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :before-close="handleCloseAdd">
      <el-form ref="addFormEl" :model="customInfo" :rules="formRules" size="small" label-width="120px">
        <el-form-item label="学员姓名：" required>
          <el-input v-model="customInfo.name" maxlength="50" placeholder="请输入学员学员姓名" style="width:240px" />
        </el-form-item>
        <el-form-item label="手机号：" required>
          <p>{{ customInfo.phone }}</p>
        </el-form-item>
        <el-form-item label="证件类型：" prop="type">
          <el-select v-model="customInfo.type" placeholder="请选择证件类型" style="width:240px">
            <el-option label="身份证" :value="1" />
            <el-option label="护照" :value="2" />
            <el-option label="军官证" :value="3" />
            <el-option label="港澳台证件" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="学员证件号：" prop="idCard">
          <el-input v-model="customInfo.idCard" maxlength="50" placeholder="请输入学员证件号" style="width:240px" />
        </el-form-item>
        <el-form-item label="学员证件照：" prop="imgUrl">
          <PictureUpload v-model="customInfo.imgUrl" :maxSize="1" />
          <p class="form-tips">支持扩展名: .png .jpeg .jpg 文件大小1M以内</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseAdd">取 消</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="handleSubmitAddForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 添加记录 -->
    <el-dialog
      title="添加记录"
      width="880px"
      :visible.sync="dialogRecordVisible"
      :close-on-click-modal="false"
      append-to-body
      @closed="handleCloseRecord"
    >
      <el-table v-loading="loading" :data="recordData" border>
        <el-table-column label="姓名" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加人" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertByName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :page-info="recordFilter"
        @handleCurrentChange="handleRecordCurrentChange"
        @handleSizeChange="handleRecordSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseRecord">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看学员-查看证件照片 -->
    <el-dialog
      title="查看证件照片"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :before-close="handleClose">
      <el-form :model="picForm" size="small" label-width="120px">
        <el-form-item label="证件照片：">
          <PictureUpload v-model="picForm.imgUrl" :maxSize="1" />
          <p class="form-tips">支持扩展名: .png .jpeg .jpg 文件大小1M以内</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmitPicForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 修改成绩 -->
    <el-dialog
      title="修改成绩"
      :visible.sync="dialogEditScoreVisible"
      width="380px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :before-close="handleCloseEditScore">
      <el-form ref="scoreFormEl" :model="scoreForm" :rules="formRules" size="small" label-width="120px">
        <el-form-item label="总分：" prop="practicalScore">
          <el-input v-model="scoreForm.practicalScore" readonly placeholder="总分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
        <el-form-item label="内容创作：" prop="practicalContentCreation">
          <el-input-number v-model="scoreForm.practicalContentCreation" @input.native="changeInput($event)" :step="0.1" :min="0" :max="10" :controls="false" placeholder="得分范围为0-10分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
        <el-form-item label="语言表达：" prop="practicalLanguageExpression">
          <el-input-number v-model="scoreForm.practicalLanguageExpression" @input.native="changeInput($event)" :step="0.1" :min="0" :max="30" :controls="false" placeholder="得分范围为0-30分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
        <el-form-item label="镜头表现：" prop="practicalScreenPresence">
          <el-input-number v-model="scoreForm.practicalScreenPresence" @input.native="changeInput($event)" :step="0.1" :min="0" :max="30" :controls="false" placeholder="得分范围为0-30分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
        <el-form-item label="数据分析：" prop="practicalDataAnalysis">
          <el-input-number v-model="scoreForm.practicalDataAnalysis" @input.native="changeInput($event)" :step="0.1" :min="0" :max="20" :controls="false" placeholder="得分范围为0-20分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
        <el-form-item label="策划运营：" prop="practicalPlanOperation">
          <el-input-number v-model="scoreForm.practicalPlanOperation" @input.native="changeInput($event)" :step="0.1" :min="0" :max="10" :controls="false" placeholder="得分范围为0-10分" style="width:146px" />
          <span> 分</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseEditScore">取 消</el-button>
        <el-button type="primary" size="small" @click="handleEditScoreForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import FileExport from "@/components/FileExport.vue";
import PictureUpload from "@/components/pictureUpload.vue"
import myPagination from "@/components/myPagination.vue"
import {
  getUserList,
  userTestPlanDel,
  handleUpdateImg,
  geToAddUserInfo,
  handleAddUserInfo,
  listUserLogPage,
  handleDelUser,
  importUserPracticalScore,
  updateUserPracticalScore
} from '@/api/product/testPlanItem'
import { downloadData } from '@/api/common'
import { add } from '@/utils/handle'
import dayjs from 'dayjs';

export default {
  name: 'WrittenGrade',
  props: {
    testPlanId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: Number,
      default: -1
    },
    skuList: {
      type: Array,
      default: () => []
    }
  },
  components:{
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    FileExport,
    PictureUpload,
    myPagination
  },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        title: '',
        testProject: '',
        skuName: '',
        evaluationAll: '',
        type: '',
        contractSignName: '',
        agentName: '',
        distributName: '',
        professionalPosition: '',
        phone: '',
        contractSignIdCard: ''
      },
      list: [],
      total: 0,
      isShow: false,
      imgUrl: '',
      dialogVisible: false,
      picForm: {
        userId: '',
        imgUrl: []
      },
      addCustomPhone: '',
      addDialogVisible: false,
      skuDialogVisible: false,
      selectedSkuId: '',
      customInfo: {
        name: '',
        userId: '',
        phone: '',
        type: '',
        idCard: '',
        imgUrl: [],
      },
      formRules: {
        type: [{ required: true, message: '请选择证件类型!', trigger: 'change' }],
        idCard: [{ required: true, message: '请输入学员证件号!', trigger: 'blur' }],
        imgUrl: [{ required: true, message: '请上传学员证件照!', trigger: 'change' }],
        practicalScore: [{ required: true, message: '请输入总分!', trigger: 'change' }],
        practicalContentCreation: [{ required: true, message: '请输入内容创作分!', trigger: 'blur' }],
        practicalLanguageExpression: [{ required: true, message: '请输入语言表达分!', trigger: 'blur' }],
        practicalScreenPresence: [{ required: true, message: '请输入镜头表现分!', trigger: 'blur' }],
        practicalDataAnalysis: [{ required: true, message: '请输入数据分析分!', trigger: 'blur' }],
        practicalPlanOperation: [{ required: true, message: '请输入策划运营分!', trigger: 'blur' }],
      },
      loading: false,
      dialogRecordVisible: false,
      recordFilter: {
        page: 1,
        limit: 10,
        total: 0
      },
      recordData: [],
      dialogEditScoreVisible: false,
      scoreForm: {
        practicalScore: '0',
        practicalContentCreation: undefined,
        practicalLanguageExpression: undefined,
        practicalScreenPresence: undefined,
        practicalDataAnalysis: undefined,
        practicalPlanOperation: undefined,
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getUserList({...this.filter, testPlanId: this.testPlanId})
      this.list = res.data.records
      this.total = +res.data.total
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    // 导出
    handleExport () {
      const params = {
        ...this.filter,
        testPlanId: this.testPlanId
      }
      delete params.page
      delete params.limit
      this.$refs.FileExport.init(
        params, // 搜索表单参数
        "jsw-product-provider", // 后端对应业务线服务
        "/adm/userTestPlan/export", // 导出-对应的接口
        1, //  状态：0get、1post
        "学员列表.xlsx" //文件名称
      );
    },
    // 下载导入模版
    downloadTemplate () {
      let url = '/product/adm/userTestPlan/downloadScoreTemplate'
      if (this.type === 1) {
        url = '/product/adm/userTestPlan/downloadTheoryScoreTemplate'
      }
      downloadData(
        url,
        {},
        '学员成绩导入模版'
      )
    },
    // 导入实操能力考核成绩
    handleImportScore (file) {
      const formData = new FormData()
      formData.append('file', file.file)
      importUserPracticalScore(formData, this.testPlanId, this.type).then(({ code, data }) => {
        if (code === 0) {
          let message = ''
          if (data.msgList && data.msgList.length !== 0) {
            message += "<div style='max-height:500px;overflow:auto'><div style='white-space:pre-wrap;margin:5px'>"
            data.msgList.forEach(t => {
              message += `\n${t}`
            })
            message += '</div></div>'
          }
          this.$notify({
            title: `导入完毕！成功${data.successCount}条，失败${data.errorCount}条`,
            dangerouslyUseHTMLString: true,
            message,
            duration: 0
          })
          this.search()
        }
      })
    },
    // 添加学员
    toAdd () {
      if (this.skuList && this.skuList.length > 1) {
        this.selectedSkuId = ''
        this.skuDialogVisible = true
        return
      }
      this.selectedSkuId = this.skuList && this.skuList.length === 1 ? this.skuList[0].skuId : ''
      this.doAdd()
    },
    // 选择班级后添加
    confirmSkuAndAdd () {
      this.skuDialogVisible = false
      this.doAdd()
    },
    doAdd () {
      const params = {
        phone: this.addCustomPhone,
        testPlanId: this.testPlanId,
        skuId: this.selectedSkuId
      }
      geToAddUserInfo(params).then(({ code, data }) => {
        if (code === 0) {
          this.customInfo.name = data.name
          this.customInfo.userId = data.userId
          this.customInfo.phone = data.phone
          this.addDialogVisible = true
        }
      })
    },
    // 补全信息
    handleSubmitAddForm () {
      this.$refs.addFormEl.validate(valid => {
        if (valid) {
          const params = Object.assign(
            { testPlanId: this.testPlanId },
            { skuId: this.selectedSkuId },
            this.customInfo,
            { imgUrl: this.customInfo.imgUrl[0].url }
          )
          this.loading = true
          handleAddUserInfo(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('添加学员成功!')
              this.handleCloseAdd()
              this.search()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 点击添加记录
    toViewRecord () {
      this.recordFilter.testPlanId = this.testPlanId
      this.handleSearchRecord(1)
      this.dialogRecordVisible = true
    },
    handleSearchRecord (page) {
      this.loading = true
      if (page) {
        this.recordFilter.page = page
      }
      listUserLogPage(this.recordFilter)
        .then(({ code, data }) => {
          if (code === 0) {
            this.recordData = data.records
            this.recordFilter.total = parseInt(data.total)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    toCancle(row) {
      if (dayjs().isAfter(dayjs(row.testFrom).subtract(1, 'day'))) {
        this.$message.warning('考场开始时间前一天内不可以取消报名!')
        return
      }
      this.$confirm(`确认取消用户${row.contractSignName}的报名?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await userTestPlanDel({id: row.id})
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      }).catch(() => {})
    },
    lookPic(row) {
      if (this.testPlanId) {
        this.picForm.userId = row.userId
        this.picForm.imgUrl = row.imgUrl ? [{ url: row.imgUrl }] : []
        this.dialogVisible = true
        return
      }
      this.imgUrl = row.imgUrl
      this.isShow = true
    },
    // 点击修改成绩
    toEditScore(row) {
      this.scoreForm.id = row.id
      this.scoreForm.practicalContentCreation = row.practicalContentCreation || 0
      this.scoreForm.practicalLanguageExpression = row.practicalLanguageExpression || 0
      this.scoreForm.practicalScreenPresence = row.practicalScreenPresence || 0
      this.scoreForm.practicalDataAnalysis = row.practicalDataAnalysis || 0
      this.scoreForm.practicalPlanOperation = row.practicalPlanOperation || 0
      this.dialogEditScoreVisible = true
    },
    // 修改成绩
    handleEditScoreForm() {
      this.$refs.scoreFormEl.validate(valid => {
        if (valid) {
          updateUserPracticalScore(this.scoreForm).then(({ code }) => {
            if (code === 0) {
              this.$message.success('修改成功!')
              this.getList()
              this.handleCloseEditScore()
            }
          })
        }
      })
    },
    // 删除学员
    toDelete ({ testPlanId, userId }) {
      this.$confirm(`是否确认删除学员?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const params = { testPlanId, userId }
        const res = await handleDelUser(params)
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('删除学员成功！')
        this.getList()
      })
    },
    closeImgViewer() {
      this.isShow = false
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleSubmitPicForm() {
      if (this.picForm.imgUrl.length === 0) {
        this.$message.warning('请上传证件照片!')
        return
      }
      const params = {
        ...this.picForm,
        imgUrl: this.picForm.imgUrl[0].url
      }
      handleUpdateImg(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('保存成功!')
          this.getList()
          this.handleClose()
        }
      })
    },
    handleClose() {
      this.picForm = this.$options.data().picForm
      this.dialogVisible = false
    },
    handleCloseAdd() {
      this.customInfo = this.$options.data().customInfo
      this.$refs.addFormEl && this.$refs.addFormEl.resetFields()
      this.addDialogVisible = false
    },
    handleCloseEditScore() {
      this.scoreForm = this.$options.data().scoreForm
      this.$refs.scoreFormEl && this.$refs.scoreFormEl.resetFields()
      this.dialogEditScoreVisible = false
    },
    // 切换页数
    handleRecordCurrentChange(payload) {
      this.handleSearchRecord(payload)
    },
    // 切换每页条数
    handleRecordSizeChange(payload) {
      this.recordFilter.limit = payload
      this.handleSearchRecord(1)
    },
    handleCloseRecord () {
      this.recordFilter = this.$options.data().recordFilter
      this.recordData = []
      this.dialogRecordVisible = false
    },
    changeInput(e) {
      if (e.target.value.indexOf('.') >= 0) {
        e.target.value = e.target.value.substring(0, e.target.value.indexOf('.') + 2);
      }
    }
  },
  watch: {
    'scoreForm': {
      handler (val) {
        const t = this.scoreForm
        const r1 = add(t.practicalContentCreation || 0, t.practicalLanguageExpression || 0)
        const r2 = add(t.practicalScreenPresence || 0, t.practicalDataAnalysis || 0)
        const r3 = add(r1, r2)
        this.scoreForm.practicalScore = add(r3, t.practicalPlanOperation || 0)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.isProp {
  .el-card {
    box-shadow: none;
    background: none;
    border: none;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
}
</style>
